import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "isShow", "defaultType", "dataSource"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 14:42:21
 * @LastEditTime: 2021-07-02 15:16:20
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import classnames from 'classnames';
import Modal from '@/components/Modal';
import { Iconfont } from '@/baseComponents'; // import './CustomerService.less';

const CustomerService = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    isShow = true,
    defaultType = 'phone',
    dataSource = []
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    'components-customer-service-render': true,
    [className]: !!className
  });
  const curr = dataSource.find((item = {}) => item.type === defaultType) || {};
  const {
    value
  } = curr;

  const onClickPhone = async () => {
    const message = /*#__PURE__*/React.createElement("div", {
      className: "toolbar-telphone-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-title"
    }, "\u4F17\u5B89\u5BA2\u670D\u7535\u8BDD"), /*#__PURE__*/React.createElement("div", {
      className: "content-desc"
    }, value));

    const onClickConfirm = () => {
      window.location.href = `tel:${value}`;
      Modal.hide();
    };

    const operations = [{
      children: '取消'
    }, {
      type: 'primary',
      children: '拨打电话',
      onClick: onClickConfirm
    }];
    Modal.show({
      children: message,
      operations
    });
  };

  const onClick = () => {
    if (defaultType === 'phone') {
      onClickPhone();
    } else {
      window.location.href = value;
    }
  };

  if (!isShow) {
    return null;
  }

  if (!value) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref,
    onClick: onClick
  }, others), /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon",
    type: "kefu"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, "\u5BA2\u670D"));
});
export default CustomerService;